import isPropValid from '@emotion/is-prop-valid';

export const ShouldNotForwardProps = (excludeProps: string[]) => (propName: PropertyKey) => {
    const propNameString = String(propName);
    return isPropValid(propNameString) && !excludeProps.includes(propNameString);
};
